"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusDetail = exports.useBonus = exports.useBonusRecord = void 0;
const react_1 = require("react");
const interface_1 = require("../../interface");
const apis_1 = require("../../apis");
/**
 * 获取发财金使用记录
 * @param isActive 是否默认加载
 * @returns 发财金信息，错误信息，loading状态...
 */
function useBonusRecord(type = interface_1.BonusSupportType.open_futures_lite, isActive = true) {
    const [page, setPage] = (0, react_1.useState)("");
    const [data, setData] = (0, react_1.useState)();
    const [refresh, setRefresh] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const [err, setErr] = (0, react_1.useState)(null);
    const fetchData = (0, react_1.useCallback)((pageToken, fetchType) => {
        const isRefresh = fetchType === "refresh";
        const setLoadingFn = isRefresh ? setRefresh : setLoading;
        setLoadingFn(true);
        apis_1.BonusAPI.getRecords(type, pageToken).subscribe({
            next: (res) => {
                const { results, next_page_token } = res;
                setData((prev) => (pageToken === "" ? results : (prev || []).concat(results || [])));
                setLoadingFn(false);
                setPage(next_page_token);
                setHasMore(!!next_page_token);
                setErr(null);
            },
            error: (e) => {
                setLoadingFn(false);
                setErr(e);
            },
        });
    }, [type]);
    (0, react_1.useEffect)(() => {
        if (isActive) {
            fetchData("", "refresh");
        }
    }, [fetchData, isActive]);
    const loadMore = (0, react_1.useCallback)(() => {
        if (loading || !hasMore) {
            return;
        }
        fetchData(page, "loading");
    }, [fetchData, hasMore, loading, page]);
    const onRefresh = (0, react_1.useCallback)(() => {
        if (refresh) {
            return;
        }
        fetchData("", "refresh");
    }, [fetchData, refresh]);
    return {
        data,
        loading,
        err,
        refresh,
        loadMore,
        onRefresh,
        hasMore,
    };
}
exports.useBonusRecord = useBonusRecord;
/**
 * 获取用户发财金
 * @param isActive 是否默认加载
 * @returns 发财金信息，loading状态，错误信息
 */
const useBonus = (isActive) => {
    const [bonusInfo, setBonusInfo] = (0, react_1.useState)({ loading: isActive === true });
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = apis_1.BonusAPI.getBonus().subscribe({
            next: (data) => {
                setBonusInfo({ data: data, loading: false });
            },
            error: (err) => {
                setBonusInfo({ error: err, loading: false });
            },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [isActive]);
    return bonusInfo;
};
exports.useBonus = useBonus;
/**
 * hooks 获取单个发财金详细信息
 * @param id 发财金 ID
 * @returns
 */
const useBonusDetail = (id) => {
    const [data, setData] = (0, react_1.useState)({ loading: true });
    (0, react_1.useEffect)(() => {
        const sub = apis_1.BonusAPI.getDetail(id).subscribe({
            next: (data) => {
                setData({ data: data, loading: false });
            },
            error: (err) => {
                setData({ error: err, loading: false });
            },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [id]);
    return data;
};
exports.useBonusDetail = useBonusDetail;
